<script lang="ts" generics="ITEM">
    import type {SearchParams, ViewableSearch} from 'src/typings';
    import {exists} from 'shared/utils/custom-utils';
    import KpSearchPageSizeSelector from './KpSearchPageSizeSelector.svelte';
    import type {SearchManager} from '../search-manager/search-manager';
    import type {Observable} from 'rxjs';

    export let searchManager: SearchManager<ITEM>;
    export let showing = false;

    let lastSearch: Observable<ViewableSearch<SearchParams, ITEM>>;
    $: lastSearch = searchManager.getLastSearch$();
    $: showing = exists($lastSearch) && $lastSearch.features && $lastSearch.features.includes('pageSizeChanging');

    function onPageSizeChange(pageSize: number) {
        searchManager.newSearchWithPartialParams({pageSize});
    }
</script>

{#if showing}
    <KpSearchPageSizeSelector currentSize={$lastSearch.result.pageSize}
                              availableSizes={[10,20,30]}
                              on:change-page-size={(event) => onPageSizeChange(event.detail)}/>
{/if}
